import React from "react";
import "./Experiences.css";

const experiences = [
  {
    title: "Développeur Web Freelance",
    company: "À mon compte",
    location: "Télétravail, Antananarivo",
    period: "Depuis 2017",
    highlights: [
      "Gestion complète de comptes clients, incluant la configuration, la sécurisation et l’administration de serveurs Cpanel pour garantir la disponibilité et la performance des sites web.",
      "Conception, création et optimisation de bases de données MySQL robustes pour des applications web évolutives et sécurisées.",
      "Installation, personnalisation et maintenance de CMS et frameworks majeurs (WordPress, Prestashop, Laravel, Symfony, Joomla) selon les besoins spécifiques de chaque projet.",
      "Développement de thèmes et plugins WordPress sur mesure, notamment avec Oxygen, Elementor, WPBakery et SP Page Builder, pour des interfaces modernes et responsives.",
      "Intégration et personnalisation avancée d’Odoo v16 (Community & Enterprise) et de Zoho CRM, incluant la création de modules, l’automatisation de workflows et l’optimisation des processus métier.",
      "Mise en œuvre de stratégies SEO techniques et éditoriales pour améliorer la visibilité des sites sur Google et augmenter le trafic organique.",
      "Gestion complète de l’hébergement, administration système et réseau, incluant la gestion des sauvegardes, la supervision proactive et la sécurisation des infrastructures.",
      "Accompagnement personnalisé des clients dans la digitalisation de leurs processus, avec un focus sur la qualité, la fiabilité et la scalabilité des solutions.",
      "Formation et support technique aux utilisateurs pour assurer une prise en main rapide et efficace des outils déployés.",
      "Utilisation de Docker pour la containerisation des applications, facilitant le déploiement et la maintenance multi-environnements.",
      "Gestion du versioning et collaboration avec Git pour un suivi rigoureux des évolutions et une meilleure coordination avec d’autres développeurs ou équipes.",
      "Déploiement et gestion d’infrastructures cloud sur AWS, assurant haute disponibilité, sécurité et montée en charge des applications.",
    ],
    skills: [
      "PHP",
      "JavaScript",
      "Python",
      "Odoo",
      "Zoho",
      "WordPress",
      "Prestashop",
      "Joomla",
      "SEO",
      "Docker",
      "Git",
      "AWS",
    ],
  },
  {
    title: "Administrateur Systèmes et Réseaux",
    company: "MADA J S",
    location: "Antananarivo",
    period: "2017 - 2020",
    highlights: [
      "Gestion de l’interconnexion avec les FAI et optimisation du réseau local pour garantir la stabilité et la rapidité des communications.",
      "Supervision et maintenance proactive du parc informatique (ordinateurs, imprimantes, périphériques) pour assurer un environnement de travail fiable et sécurisé.",
      "Installation, configuration et maintenance de serveurs stratégiques (firewall, stockage, VoIP), avec une attention particulière à la sécurité des données et à la continuité de service.",
      "Assistance technique et formation des utilisateurs sur divers outils métiers (CRM, softphone, GPAO), favorisant l’autonomie et la productivité des équipes.",
      "Mise en place de procédures de sauvegarde et de plans de reprise d’activité pour minimiser les risques liés aux incidents informatiques.",
    ],
    skills: [
      "Administration systèmes",
      "Réseaux",
      "Sécurité",
      "VoIP",
      "Support utilisateurs",
    ],
  },
  {
    title: "Développeur Web",
    company: "MADA J S",
    location: "Antananarivo",
    period: "2018 - 2020",
    highlights: [
      "Création et mise en ligne du site web vitrine de l’entreprise, contribuant à la visibilité et à la crédibilité de la société.",
      "Maintenance évolutive du site sous WordPress et Netbeans : correction de bugs, ajout de nouvelles fonctionnalités, adaptation aux besoins des utilisateurs.",
      "Développement et suivi de formulaires de contact efficaces, facilitant la prise de contact et la génération de prospects qualifiés.",
      "Mise à jour régulière du blog d’entreprise pour améliorer le référencement naturel (SEO) et l’engagement des visiteurs.",
      "Collaboration étroite avec les équipes internes pour assurer la cohérence entre les besoins métiers et les solutions techniques.",
    ],
    skills: [
      "WordPress",
      "Netbeans",
      "PHP",
      "JavaScript",
      "SEO",
      "Gestion de contenu",
    ],
  },
  {
    title: "Développeur Web & Intervention Réseaux",
    company: "Freelance",
    location: "Antananarivo",
    period: "2016 - 2017",
    highlights: [
      "Création d’un site vitrine professionnel sous WordPress pour une société de bricolage, avec un design responsive et une navigation intuitive.",
      "Développement d’un site e-commerce complet (“NY-VITAGASY”) sous Prestashop, intégrant gestion des produits, paiements en ligne et suivi des commandes.",
      "Maintenance technique, mises à jour régulières (images, bannières, contenus), et optimisation des performances pour garantir une expérience utilisateur optimale.",
      "Conseil et accompagnement du client dans la stratégie digitale et l’évolution de ses outils web.",
      "Intervention ponctuelle sur des problématiques réseaux pour assurer la disponibilité des services en ligne.",
    ],
    skills: [
      "WordPress",
      "Prestashop",
      "PHP",
      "E-commerce",
      "Maintenance web",
      "Conseil digital",
    ],
  },
  {
    title: "Intégrateur Web",
    company: "Web Spirit Création - WSC",
    location: "Antananarivo",
    period: "2010 - 2012",
    highlights: [
      "Insertion et mise à jour d’articles et d’images sur divers sites web, contribuant à la fraîcheur et à la pertinence des contenus publiés.",
      "Mise en page soignée des articles avec gestion avancée des liens (follow/nofollow), participant à l’optimisation SEO et à la qualité éditoriale.",
      "Vérification régulière des liens de redirection pour garantir une expérience utilisateur fluide et éviter les erreurs 404.",
      "Collaboration avec les équipes éditoriales et techniques pour assurer la cohérence et la rapidité des mises à jour.",
      "Participation à la veille technologique sur les bonnes pratiques d’intégration et de référencement.",
    ],
    skills: ["CMS", "SEO", "HTML/CSS", "Gestion de contenu", "Intégration web"],
  },
];

const Experiences = () => (
  <section className="experiences-section">
    <h2>Expériences professionnelles</h2>
    <div className="timeline">
      {experiences.map((exp, idx) => (
        <div className="timeline-item" key={idx}>
          <div className="timeline-dot" />
          <div className="timeline-content">
            <h3>
              {exp.title} <span className="company">@ {exp.company}</span>
            </h3>
            <div className="period-location">
              <span>{exp.period}</span> | <span>{exp.location}</span>
            </div>
            <ul>
              {exp.highlights.map((h, i) => (
                <li key={i}>{h}</li>
              ))}
            </ul>
            <div className="skills-tags">
              {exp.skills.map((skill, i) => (
                <span className="skill-tag" key={i}>
                  {skill}
                </span>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default Experiences;
